import { Injectable } from '@angular/core';
import { AppConfig } from '@app/config/app.config';

@Injectable()
export class PageCalculatorService {

    calculate(totalRows: number): number {
        if (totalRows <= AppConfig.settings.env.agGridPagination.pageSize) {
            return 1;
        } else {
            let resto = totalRows % AppConfig.settings.env.agGridPagination.pageSize;
            let divisao = totalRows / AppConfig.settings.env.agGridPagination.pageSize;

            if (resto === 0) {
                return divisao;
            } else {
                return Math.ceil(divisao);
            }
        }
    }
}